const endpointLogin = {
    url: 'https://ecsapi.wwtc.app/api/Account',
    method: 'POST',
};

const endpointTranslate = {
    method: 'POST',
    url: 'https://api.wwtc.app/services/ttt/:sourceLanguage/:targetLanguage',
    valueResponse: 'translated_text',
};

const endpointTextToSpeech = {
    method: 'POST',
    url: 'https://api.wwtc.app/services/tts/:sourceLanguage/:sourceLanguage',
};

const endpointSpeechToText = {
    method: 'POST',
    url: 'https://api.wwtc.app/services/stt/:sourceLanguage/:sourceLanguage',
    valueResponse: 'source_text',
    isFormData: false,
};

const endpointDetectLanguage = {
    method: 'POST',
    url: 'https://api.wwtc.app/services/stt/detect-language',
    valueResponse: 'source_text',
    isFormData: true,
};

const urlTestConnection = 'https://app.wwtc.app/testmicrophone/index';

function signedEndpoint(apiToken, endpoint) {
    const cookieRegex = document.cookie.match(new RegExp(`(?:^|;\\s*)anonymous-id=([^;]*)`));
    const apiAnonymousId = cookieRegex ? '&apiAnonymousID=' + cookieRegex[1] : '';

    let operator = '?';
    if (endpoint.url.includes(operator)) {
        operator = '&';
    }

    return {
        method: endpoint.method,
        url: endpoint.url + operator + 'apiAuthorization=' + apiToken + apiAnonymousId,
        valueResponse: endpoint.valueResponse,
        isFormData: endpoint.isFormData,
    };
}

export {
    endpointSpeechToText,
    endpointTextToSpeech,
    endpointTranslate,
    endpointLogin,
    urlTestConnection,
    endpointDetectLanguage,
    signedEndpoint,
};
